module.exports = __webpack_public_path__ + "img/psujgojvki7qb8er8s4hwi8om3peckzl2v544665dd-b0ae-4564-a017-e07409303564.59134a02.png";